<div class="boards-container">
    <!-- Page Header -->
    <div class="boards-header">
        <div class="header-content">
            <h2 class="boards-title">
                <fa-icon [icon]="icons.faTableColumns" class="title-icon"></fa-icon>
                My Boards
            </h2>
            <p class="boards-subtitle">Access and manage all your boards</p>
        </div>
    </div>

    <!-- Boards Grid -->
    <div class="boards-grid" *ngIf="boards && boards.length > 0">
        <a 
            *ngFor="let board of boards"
            [routerLink]="['/boards', board.board]"
            class="board-card"
        >
            <div class="card-icon">
                <fa-icon [icon]="icons.faTableColumns"></fa-icon>
            </div>
            <div class="card-content">
                <h3 class="board-name">{{ board.board }}</h3>
                <p class="board-meta">Click to open board</p>
            </div>
        </a>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!boards || boards.length === 0">
        <div class="empty-content">
            <fa-icon [icon]="icons.faBoxOpen" class="empty-icon"></fa-icon>
            <h3 class="empty-title">No Boards Yet</h3>
            <p class="empty-description">You don't have any boards yet. Create your first board to get started.</p>
            <button class="btn-create-board">
                <fa-icon [icon]="icons.faPlus"></fa-icon>
                Create New Board
            </button>
        </div>
    </div>

</div>